import { ProductOrganizationDialogConfig, FieldType, ProductOrganizationTableTemplate } from '../../product.model';

export const ticketsDialogConfig: ProductOrganizationDialogConfig = {
	title: 'Bilety',
	configType: 'tickets',
	fields: [
		{ key: 'name', label: 'Nazwa', type: FieldType.TEXT, required: true },
		{ key: 'www', label: 'WWW', type: FieldType.TEXT, placeholder: 'https://example.com' },
		{ key: 'note', label: 'Notatka', type: FieldType.TEXTAREA },
	],
};

export const ticketsTableTemplate: ProductOrganizationTableTemplate[] = [
	...ticketsDialogConfig.fields.map((field) => ({
		key: field.key,
		label: field.label,
	})),
	{ key: 'createdBy', label: 'Utworzone przez' },
	{ key: 'createdAt', label: 'Utworzone' },
	{ key: 'edit', label: '' },
];
